import { defineStore } from 'pinia'

export const useLoadingStore = defineStore('loading', {
  state: () => ({
    loadingCount: 0,
    loadingMessage: '' as string | null,
    appReady: false,
    appError: null as string | null,
  }),
  
  getters: {
    isLoading: (state) => state.loadingCount > 0
  },
  
  actions: {
    startLoading(message?: string) {
      this.loadingCount++
      if (message) {
        this.loadingMessage = message
      }
    },
    
    stopLoading() {
      if (this.loadingCount > 0) {
        this.loadingCount--
      }
      if (this.loadingCount === 0) {
        this.loadingMessage = null
      }
    },
    
    resetLoading() {
      this.loadingCount = 0
      this.loadingMessage = null
    },

    setAppReady(value = true) {
      this.appReady = value
      if (value) {
        this.appError = null
      }
    },

    setAppError(message: string) {
      this.appError = message
    },

    clearAppError() {
      this.appError = null
    }
  }
})
